import React from 'react';
import { MediaHubImageSearchFeature, TrackingContext } from '../../../../../MediaHub/MediaHubImageSearchFeature';
import { HandleAddImage } from '../ImagePickerModal.types';

interface StockPhotoTabProps {
  initialQuery: string;
  handleAddImage: HandleAddImage;
  setUserSearchedForStockPhotos: (value: boolean) => void;
  trackingContext: TrackingContext;
}

export const StockPhotoTab: React.FC<StockPhotoTabProps> = ({
  handleAddImage,
  initialQuery,
  setUserSearchedForStockPhotos,
  trackingContext,
}) => {
  const handleImageSelection = (url: URL) => {
    handleAddImage({ urls: [url.toString()], source: 'stockImage' });
  };

  return (
    <MediaHubImageSearchFeature
      onSelection={handleImageSelection}
      initialQuery={initialQuery}
      onSearched={() => setUserSearchedForStockPhotos(true)}
      trackingContext={trackingContext}
    />
  );
};
